import React from 'react';

const BlogTags = () => {
    return (
        <div className="tags">
            <p>
                <a title="Wedding" href={ process.env.PUBLIC_URL + "/blog" }>Wedding</a>
                <a title="Wedding Rings" href={ process.env.PUBLIC_URL + "/blog" }>Wedding Rings</a>
                <a title="Engagement Rings" href={ process.env.PUBLIC_URL + "/blog" }>Engagement Rings</a>
            </p>
        </div>
    );
};

export default BlogTags;